import { render, staticRenderFns } from "./SubtitleList.vue?vue&type=template&id=90b781ce&scoped=true&"
import script from "./SubtitleList.vue?vue&type=script&lang=js&"
export * from "./SubtitleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b781ce",
  null
  
)

export default component.exports